// Apolo IDE — Breakpoint strategy (Sprint v6).
//
// Shell collapses at md: (768px) so iPad portrait (810px) renders the
// desktop layout. Below md the shell is mobile-first (drawers, bottom
// sheets, overflow menus). Above xl (1280px) the side panel is split,
// not overlay — see SidePanelDrawer (B6).

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

export const TARGET_VIEWPORTS = {
  'iphone-15':       { width: 393,  height: 852 },
  'ipad-portrait':   { width: 810,  height: 1080 },
  'macbook-13':      { width: 1280, height: 800 },
  'macbook-pro-16':  { width: 1728, height: 1117 },
  'studio-display':  { width: 2560, height: 1440 },
};
